import {
  Integration,
  IntegrationAction,
  RawIntegration
} from '../../shared/interfaces/integration';
import { EntityActions } from '../../entity-actions/EntityActions';
import { PIPELINE_ACTIONS_CONFIRMATION_DIALOG_PROPS } from './constants/pipeline-actions';
import { IntegrationFactory } from '../factories/integrationFactory';

interface PipelineActionsProps {
  pipeline: Integration;
  updatePipeline: (pipeline: Integration) => void;
}

export function PipelineActions({ pipeline, updatePipeline }: PipelineActionsProps) {
  return (
    <EntityActions<IntegrationAction, Integration>
      actions={pipeline.actions}
      entity={pipeline}
      updateEntityOnSuccess={updatePipeline}
      confirmationDialogProps={PIPELINE_ACTIONS_CONFIRMATION_DIALOG_PROPS}
      getEntityFromActionResponse={res => IntegrationFactory(res as RawIntegration)}
      menuLabel='Pipeline Actions'
    />
  );
}
